// import { DEBUGTIME_LOCALSTORAGE_KEY, DEBUGTIME_NOW } from '@/constant/eventInfo/eventData'
import moment from 'moment'

const DEBUGTIME_LOCALSTORAGE_KEY = 'debugtime_2022oct'
const DEBUGTIME_NOW = '' //'2020-02-02 02:02:02' //※ここに時間を入れるとローカルストレージより優先

// const reg = /20\d{2}-[01]\d-[0-3]\d\s[0-2]\d\:[0-5]\d(?:\:[0-5]\d)*/
const reg = /20\d{2}-[01]\d-[0-3]\d(?:\s[0-2]\d\:[0-5]\d(?:\:[0-5]\d)*)*/

export class NowTime {
  constructor() {}

  get now() {
    let rtn = null
    if (!!window) {
      if (!!DEBUGTIME_NOW && reg.test(DEBUGTIME_NOW)) {
        // DEBUG_NOW_TIME優先 DEBUG_NOW_TIMEからかえす
        rtn = new moment(DEBUGTIME_NOW)
      } else {
        const lstime = localStorage.getItem(DEBUGTIME_LOCALSTORAGE_KEY)
        const mtc = !!lstime ? lstime.match(reg) : null
        if (!!lstime && !!mtc && !!mtc[0]) {
          // ローカルストレージから返す
          rtn = new moment(mtc[0])
        } else {
          // 現在時刻を返す
          rtn = new moment()
        }
      }
    }
    return rtn
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/nowTime.js